import { createApp } from 'vue'
import App from './App.vue'
import router from "@/router";
import store from "@/store";
import i18n from './i18n'
import { inject } from "@vercel/analytics"

// Injecte le script de tracking Vercel Analytics
inject()

import * as Sentry from "@sentry/vue";

const app = createApp(App);

Sentry.init({
	app,
	dsn: "https://30e537ebbf4ebff3fd1c40708e913397@o4509444975362048.ingest.de.sentry.io/4509444976607312",
	// Setting this option to true will send default PII data to Sentry.
	// For example, automatic IP address collection on events
	sendDefaultPii: true
});

// Load router
app.use(router);
app.use(store);
app.use(i18n);

app.mount("#app");
